<template>
  <div ref="body">
    <custom-header active="global" :subActive="current"></custom-header>

    <div class="content-container">
      <div class="form-header">
        <h1 class="page-title text-bold">2027深圳国际家具展</h1>
        <h2 class="page-subtitle text-bold">中国家具企业出海合作登记表</h2> 
        <p class="page-desc">助力中国家具品牌连接全球采购商、渠道商、设计机构及工程项目客户。</p>
        <p class="page-desc">请填写以下信息，我们将根据您的产品优势、海外市场布局及合作需求，为您匹配精准海外合作机会。</p>
      </div>

      <div class="form-container">
        <van-form @submit="onSubmit" @failed="onFailed">
          
          <!-- 一、企业信息 -->
          <div class="form-section">
            <div class="section-title">
              <span class="title-num">一</span>
              <span class="title-text">企业信息</span>
            </div>
            
            <van-field
              v-model="formData.companyName"
              name="companyName"
              label="企业名称"
              placeholder="请输入企业名称"
              :rules="[{ required: true, message: '请填写企业名称' }]"
            />
            
            <van-field
              v-model="formData.contactName"
              name="contactName"
              label="联系人姓名"
              placeholder="请输入联系人姓名"
              :rules="[{ required: true, message: '请填写联系人姓名' }]"
            />
            
            <van-field
              v-model="formData.position"
              name="position"
              label="职位"
              :rules="[{ required: true, message: '请选择职位' }]"
            >
              <template #input>
                <div class="position-group" :style="isPC ? positionGroupStylePC : groupStyleMobile">
                  <span  v-for="item in positionOptions" :key="item" class="option-item">
                    <input name="position" type="radio" v-model="formData.position" :value="item" @click="selectPosition(item)" />
                    <label @click="selectPosition(item)">{{ item }} </label>
                  </span> 
                  
                   <input
                    v-if="formData.position === '其他'"
                    v-model="formData.positionOther"
                    type="text"
                    placeholder="请输入具体职位"
                    class="position-other-input"
                    /> 
                </div>
              </template>
            </van-field>
            
            <van-field
              v-model="formData.phone"
              name="phone"
              label="联系电话/WhatsApp"
              placeholder="请输入联系电话或WhatsApp"
            />
            
            <van-field
              v-model="formData.email"
              name="email"
              label="企业邮箱"
              placeholder="请输入企业邮箱"
              :rules="[
                { required: true, message: '请填写企业邮箱' },
                { type: 'email', message: '请填写正确的邮箱地址' }
              ]"
            />
            
            <van-field
              v-model="formData.website"
              name="website"
              label="企业官网/品牌网站"
              placeholder="请输入企业官网或品牌网站"
            />
            
            <!-- 移动端地区选择 -->
            <div v-if="!isPC" class="mobile-location">
              <div class="mobile-location-label">企业所在地</div>
              <div class="mobile-location-input" @click="showLocationPicker = true">
                <span v-if="formData.location" class="mobile-location-value">{{ formData.location }}</span>
                <span v-else class="mobile-location-placeholder">请选择省市区</span>
                <span class="mobile-location-arrow">›</span>
              </div>
            </div>
            
            <!-- PC端地区选择 -->
            <div v-if="isPC" class="pc-location-wrap">
              <div class="pc-location-label">企业所在地</div>
              <div class="pc-location-selects">
                <el-select
                  ref="provinceSelect"
                  v-model="selectedProvinceId"
                  placeholder="请选择省份"
                  @change="onProvinceChange"
                  popper-class="pc-select-dropdown"
                  class="pc-location-select"
                >
                  <el-option
                    v-for="p in provinceOptions"
                    :key="p.value"
                    :label="p.text"
                    :value="p.value"
                  />
                </el-select>
                <el-select
                  ref="citySelect"
                  :key="'city-' + selectedProvinceId"
                  v-model="selectedCityId"
                  placeholder="请选择城市"
                  :disabled="!selectedProvinceId"
                  @change="onCityChange"
                  popper-class="pc-select-dropdown"
                  class="pc-location-select"
                >
                  <el-option
                    v-for="c in cityOptions"
                    :key="c.value"
                    :label="c.text"
                    :value="c.value"
                  />
                </el-select>
                <el-select
                  ref="districtSelect"
                  :key="'district-' + selectedCityId"
                  v-model="selectedDistrictId"
                  placeholder="请选择区/县"
                  :disabled="!selectedCityId"
                  @change="onDistrictChange"
                  popper-class="pc-select-dropdown"
                  class="pc-location-select"
                >
                  <el-option
                    v-for="d in districtOptions"
                    :key="d.value"
                    :label="d.text"
                    :value="d.value"
                  />
                </el-select>
              </div>
            </div>
            
          </div>

          <!-- 二、产品供应信息 -->
          <div class="form-section">
            <div class="section-title">
              <span class="title-num">二</span>
              <span class="title-text">产品供应信息</span>
            </div>
            
            <div class="question">
              <div class="question-title">您主要供应哪些产品？<span class="hint">（可多选）</span></div>
              <div class="check-group" :style="isPC ? groupStylePC : groupStyleMobile">
                <span v-for="item in productOptions" :key="item.value" class="option-item">
                  <input name="products" type="checkbox" v-model="formData.products"  :value="item"  @click="toggleCheck(formData.products, item)"  />
                  <label @click="toggleCheck(formData.products, item)" >{{ item }}</label>
                </span>
              </div>
              <van-field
                v-if="formData.products.includes('家装建材（请填写具体产品）')"
                v-model="formData.buildingDetail"
                placeholder="请填写具体产品，如门窗、卫浴、瓷砖等"
                class="sub-field"
              />
              <van-field
                v-if="formData.products.includes('其他')"
                v-model="formData.productOther"
                placeholder="请填写其他产品"
                class="sub-field"
              />
            </div>
            
            <div class="question">
              <div class="question-title">产品主要材质<span class="hint">（可多选）</span>：</div>
              <div class="check-group" :style="isPC ? groupStylePC : groupStyleMobile">
                <span v-for="item in materialOptions" :key="item" class="option-item">
                  <input name="materials" type="checkbox" v-model="formData.materials"  :value="item"  @click="toggleCheck(formData.materials, item)"  />
                  <label @click="toggleCheck(formData.materials, item)" >{{ item }}</label>
                </span>
              </div>
            </div>
            
            <div class="question">
              <div class="question-title">产品设计风格<span class="hint">（可多选）</span>：</div>
              <div class="check-group" :style="isPC ? groupStylePC : groupStyleMobile"> 
                <span v-for="item in styleOptions" :key="item.value" class="option-item">
                  <input name="styles" type="checkbox" v-model="formData.styles"  :value="item"  @click="toggleCheck(formData.styles, item)"  />
                  <label @click="toggleCheck(formData.styles, item)" >{{ item }}</label>
                </span> 
              </div>
            </div>
          </div>

          <!-- 三、海外业务情况 -->
          <div class="form-section">
            <div class="section-title">
              <span class="title-num">三</span>
              <span class="title-text">海外业务情况</span>
            </div>
            
            <div class="question">
              <div class="question-title">目前是否开展海外业务？</div>
              <div class="check-group" :style="isPC ? groupStylePC : groupStyleMobile">
                <span  v-for="item in businessStatusOptions" :key="item" class="option-item">
                  <input name="position" type="radio" v-model="formData.businessStatus" :value="item" @click="selectBusinessStatus(item)" />
                  <label @click="selectBusinessStatus(item)">{{ item }} </label>
                </span> 
              </div>
            </div>
            
            <div class="question">
              <div class="question-title">当前主要出口市场<span class="hint">（可多选）</span>：</div>
              <div class="check-group" :style="isPC ? groupStylePC : groupStyleMobile">
                <span v-for="item in marketOptions" :key="item.value" class="option-item">
                  <input name="currentMarkets" type="checkbox" v-model="formData.currentMarkets"  :value="item"  @click="toggleCheck(formData.currentMarkets, item)"  />
                  <label @click="toggleCheck(formData.currentMarkets, item)" >{{ item }}</label>
                </span>
              </div>
            </div>
            
            <div class="question">
              <div class="question-title">未来希望开发市场<span class="hint">（可多选）</span>：</div>
              <div class="check-group" :style="isPC ? groupStylePC : groupStyleMobile">
                <span v-for="item in marketOptions" :key="item.value" class="option-item">
                  <input name="targetMarkets" type="checkbox" v-model="formData.targetMarkets"  :value="item"  @click="toggleCheck(formData.targetMarkets, item)"  />
                  <label @click="toggleCheck(formData.targetMarkets, item)" >{{ item }}</label>
                </span>
              </div>
            </div>
          </div>

          <!-- 四、希望获得的海外合作机会 -->
          <div class="form-section">
            <div class="section-title">
              <span class="title-num">四</span>
              <span class="title-text">希望获得的海外合作机会</span>
            </div>
            
            <div class="question">
              <div class="question-title">希望匹配哪些海外合作伙伴？<span class="hint">（可多选）</span></div>
              <div class="check-group" :style="isPC ? groupStylePC : groupStyleMobile">
                <span v-for="item in partnerOptions" :key="item.value" class="option-item">
                  <input name="partners" type="checkbox" v-model="formData.partners"  :value="item"  @click="toggleCheck(formData.partners, item)"  />
                  <label @click="toggleCheck(formData.partners, item)" >{{ item }}</label>
                </span>
              </div>
            </div>
            
            <div class="question">
              <div class="question-title">希望开展哪些合作？<span class="hint">（可多选）</span></div>
              <div class="check-group" :style="isPC ? groupStylePC : groupStyleMobile">
                <span v-for="item in cooperationOptions" :key="item.value" class="option-item">
                  <input name="cooperation" type="checkbox" v-model="formData.cooperation"  :value="item"  @click="toggleCheck(formData.cooperation, item)"  />
                  <label @click="toggleCheck(formData.cooperation, item)" >{{ item }}</label>
                </span>
              </div>
            </div>
          </div>

          <!-- 五、海外支持能力 -->
          <div class="form-section">
            <div class="section-title">
              <span class="title-num">五</span>
              <span class="title-text">海外支持能力</span>
            </div>
            
            <div class="question">
              <div class="question-title">您具备哪些海外合作能力？<span class="hint">（可多选）</span></div>
              <div class="check-group" :style="isPC ? groupStylePC : groupStyleMobile">
                <span v-for="item in capabilityOptions" :key="item.value" class="option-item">
                  <input name="capabilities" type="checkbox" v-model="formData.capabilities"  :value="item"  @click="toggleCheck(formData.capabilities, item)"  />
                  <label @click="toggleCheck(formData.capabilities, item)" >{{ item }}</label>
                </span>
              </div>
            </div>
          </div>

          <!-- 提交说明 -->
          <div class="form-notice">
            <div class="notice-title">提交说明</div>
            <p>提交后，深圳国际家具展团队将根据您的产品类别、海外市场方向及合作需求，建立企业标签，并为您推荐匹配的海外买家及合作资源。</p>
          </div>

          <div class="submit-bar">
            <van-button type="primary" native-type="submit" :loading="isSubmitting">
              提交登记表
            </van-button>
          </div>
          
        </van-form>
      </div>
    </div>
    
    <custom-footer :friendLink="friendLink"></custom-footer>
    
    <!-- 回到顶部 -->
    <scroll-top @scrollTop="scrollTop"></scroll-top>

    <!-- 地区选择弹窗（仅移动端）-->
    <van-popup v-if="!isPC" v-model="showLocationPicker" position="bottom" round>
      <van-picker
        :columns="locationColumns"
        @change="onPickerChange"
        @confirm="onLocationConfirm"
        @cancel="showLocationPicker = false"
        title="选择企业所在地"
      />
    </van-popup>
    
  </div>
</template>

<script>
import { 
  Form, Field, Button,
  Radio, RadioGroup,
  Popup, Picker,
  Toast, Notify
} from 'vant';
import { Select, Option } from 'element-ui';
import { areaTree } from '@/data/area.js';
import customHeader from "./components/head.vue";
import customFooter from "./components/foot.vue";
import scrollTop from "./components/scrollTop.vue";
import commonMixin from './commonMixin.js';
import { submitOverseasRegister } from '@/api/index.js';
 
export default {
  components: {
    'custom-header': customHeader,
    'custom-footer': customFooter,
    'scroll-top': scrollTop,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  mixins: [commonMixin],
  metaInfo: {
    meta: [
      { name: 'keyWords', content: '深圳家具展，家具展，出海登记，家具出海，海外合作' },
      { name: 'description', content: '2027深圳国际家具展中国家具企业出海合作登记表，助力中国家具品牌连接全球采购商、渠道商、设计机构及工程项目客户。' },
    ],
  },
  data() {
    return {
      current: 'register',
      isSubmitting: false,
      showLocationPicker: false,
      isPC: window.innerWidth >= 1024, // 是否PC端
      selectedProvinceId: '',
      selectedCityId: '',
      selectedDistrictId: '',
      
      positionOptions: [
        '企业负责人', '外贸负责人', '销售负责人', '设计负责人', '其他'
      ],
      
      productOptions: [
        '客厅及餐厅家具','卧室家具', '办公家具','酒店及工程家具', 
        '户外家具', '定制家具/全屋整装', '智能家居/AI智能系统', 
        '原创设计家具','家居饰品及软装', '灯具','健康环保及可持续家居产品', 
        '家装建材（请填写具体产品）','其他'
      ],
      
      materialOptions: [
        '实木', '板材', '金属', '玻璃', '石材', '皮革', '布艺',
        '藤竹/天然材料', '再生材料', '环保可持续材料'
      ],
      
      styleOptions: [
        '现代简约', '北欧', '意式设计', '极简', '轻奢',
        '东方美学', '工业风', '商业工程风', '支持定制设计'
      ],
      
      businessStatusOptions: [
        '已有成熟出口业务',
        '已出口，希望扩大海外市场',
        '正在开发海外市场',
        '暂无出口，希望拓展海外业务'
      ],
      
      marketOptions: [
        '北美', '欧洲', '亚洲', '东南亚', '中东', '澳洲', '拉美', '非洲'
      ],
      
      partnerOptions: [
        '家具进口商',
        '家具批发商/经销商',
        '家居品牌商',
        '室内设计公司/设计师',
        '建筑设计公司/工程公司',
        '酒店集团/房地产开发商',
        '电商渠道商'
      ],
      
      cooperationOptions: [
        '产品采购',
        '长期供应合作',
        'OEM/ODM合作',
        '海外代理/经销',
        '工程项目合作',
        '品牌合作'
      ],
      
      capabilityOptions: [
        '英文产品目录',
        '英文网站',
        '产品图片/视频素材',
        '小批量采购支持',
        '产品定制开发',
        '快速打样',
        '海外售后支持',
        '国际认证（FSC/BSCI/ISO等）'
      ],
      
      // 省市区三级联动数据（从行政区.txt生成）
      locationColumns: areaTree,
      
      formData: {
        companyName: '',
        contactName: '',
        position: '',
        positionOther: '',
        phone: '',
        email: '',
        website: '',
        location: '',
        products: [],
        productOther: '',
        buildingDetail: '',
        materials: [],
        styles: [],
        businessStatus: '',
        currentMarkets: [],
        targetMarkets: [],
        partners: [],
        cooperation: [],
        capabilities: [],
      }
    }
  },
  computed: {
    provinceOptions() {
      return areaTree;
    },
    cityOptions() {
      if (!this.selectedProvinceId) return [];
      const p = areaTree.find(x => x.value === this.selectedProvinceId);
      return p ? (p.children || []) : [];
    },
    districtOptions() {
      if (!this.selectedCityId) return [];
      const p = areaTree.find(x => x.value === this.selectedProvinceId);
      if (!p) return [];
      const c = (p.children || []).find(x => x.value === this.selectedCityId);
      return c ? (c.children || []) : [];
    },
    groupStylePC() {
      return {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridRowGap: '14Px',
        gridColumnGap: '6Px',
        width: '100%',
        boxSizing: 'border-box',
      };
    },
    positionGroupStylePC() {
      return {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gridRowGap: '14Px',
        gridColumnGap: '6Px',
        width: '100%',
        boxSizing: 'border-box',
      };
    },
    groupStyleMobile() {
      return {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridRowGap: '10Px',
        gridColumnGap: '8Px',
        width: '100%',
        boxSizing: 'border-box',
      };
    }
  },
  created() {
    this._resizeHandler = () => {
      this.isPC = window.innerWidth >= 1024;
    };
    window.addEventListener('resize', this._resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._resizeHandler);
  },
  methods: {
    // 职位单选
    selectPosition(val) {
      this.formData.position = val;
      if (val !== '其他') {
        this.formData.positionOther = '';
      }
    },
    selectBusinessStatus(val) {
      this.formData.businessStatus = val; 
    },
    // 自定义多选切换
    toggleCheck(arr, val) { 
      const idx = arr.indexOf(val);
      if (idx > -1) {
        arr.splice(idx, 1);
      } else {
        arr.push(val);
      } 
      // console.log(arr);
    },
    onPickerChange(selectedValues, selectedOptions, columnIndex) {
      // console.log(selectedValues)
      // console.log(selectedOptions)
      const lastOption = selectedOptions[selectedOptions.length - 1];
      const hasChildren = lastOption && lastOption.children && lastOption.children.length > 0;
      // 当选择到最后一级（第3级）或无子项的级别（如上海只有2级），自动关闭
      // if (!hasChildren) {
      //   const parts = selectedOptions.map(o => o.text).filter(Boolean);
      //   this.formData.location = parts.join(' ');
      //   this.showLocationPicker = false;
      // }
      let parts = '';
      selectedOptions.map(o => {
        parts += '' + o
      });
      this.formData.location = parts
      this.showLocationPicker = false;
    },
    onLocationConfirm(selectedValues, selectedOptions) {
      const parts = selectedOptions.map(o => o.text).filter(Boolean);
      this.formData.location = parts.join(' ');
      this.showLocationPicker = false;
    },
    onProvinceChange(val) {
      this.selectedCityId = '';
      this.selectedDistrictId = '';
      this.updateLocationField();
      // 只有一个城市的省份（直辖市），自动选中唯一城市
      this.$nextTick(() => {
        const opts = this.cityOptions;
        if (opts.length === 1) {
          this.selectedCityId = opts[0].value;
          this.updateLocationField();
          // 只有一个区县的，也自动选中
          this.$nextTick(() => {
            const distOpts = this.districtOptions;
            if (distOpts.length === 1) {
              this.selectedDistrictId = distOpts[0].value;
              this.updateLocationField();
            }
            // 关闭下拉
            if (this.$refs.citySelect) this.$refs.citySelect.blur();
          });
        }
        // 关闭省份下拉
        if (this.$refs.provinceSelect) this.$refs.provinceSelect.blur();
      });
    },
    onCityChange(val) {
      this.selectedDistrictId = '';
      this.updateLocationField();
      // 只有一个区县的，自动选中
      this.$nextTick(() => {
        const distOpts = this.districtOptions;
        if (distOpts.length === 1) {
          this.selectedDistrictId = distOpts[0].value;
          this.updateLocationField();
        }
        if (this.$refs.citySelect) this.$refs.citySelect.blur();
      });
    },
    onDistrictChange() {
      this.updateLocationField();
      this.$nextTick(() => {
        if (this.$refs.districtSelect) this.$refs.districtSelect.blur();
      });
    },
    updateLocationField() {
      const parts = [];
      if (this.selectedProvinceId) {
        const p = areaTree.find(x => x.value === this.selectedProvinceId);
        if (p) parts.push(p.text);
      }
      if (this.selectedCityId) {
        const p = areaTree.find(x => x.value === this.selectedProvinceId);
        const c = p ? (p.children || []).find(x => x.value === this.selectedCityId) : null;
        if (c) parts.push(c.text);
      }
      if (this.selectedDistrictId) {
        const p = areaTree.find(x => x.value === this.selectedProvinceId);
        const c = p ? (p.children || []).find(x => x.value === this.selectedCityId) : null;
        const d = c ? (c.children || []).find(x => x.value === this.selectedDistrictId) : null;
        if (d) parts.push(d.text);
      }
      this.formData.location = parts.join(' ');
    },
    onSubmit(values) {
      if (!this.formData.position) {
        Toast('请选择职位');
        return;
      }
      if (this.formData.position === '其他' && !this.formData.positionOther) {
        Toast('请填写具体职位');
        return;
      }
      this.isSubmitting = true;
      
      const submitData = {
        companyName: this.formData.companyName,
        contactName: this.formData.contactName,
        position: this.formData.position === '其他' ? this.formData.positionOther : this.formData.position,
        phone: this.formData.phone,
        email: this.formData.email,
        website: this.formData.website,
        location: this.formData.location,
        products: Array.isArray(this.formData.products) ? this.formData.products.join(',') : (this.formData.products || ''),
        productOther: this.formData.productOther,
        buildingDetail: this.formData.buildingDetail,
        materials: Array.isArray(this.formData.materials) ? this.formData.materials.join(',') : (this.formData.materials || ''),
        styles: Array.isArray(this.formData.styles) ? this.formData.styles.join(',') : (this.formData.styles || ''),
        businessStatus: Array.isArray(this.formData.businessStatus)
          ? this.formData.businessStatus.join(',')
          : (this.formData.businessStatus || ''),
        currentMarkets: Array.isArray(this.formData.currentMarkets) ? this.formData.currentMarkets.join(',') : (this.formData.currentMarkets || ''),
        targetMarkets: Array.isArray(this.formData.targetMarkets) ? this.formData.targetMarkets.join(',') : (this.formData.targetMarkets || ''),
        partners: Array.isArray(this.formData.partners) ? this.formData.partners.join(',') : (this.formData.partners || ''),
        cooperation: Array.isArray(this.formData.cooperation) ? this.formData.cooperation.join(',') : (this.formData.cooperation || ''),
        capabilities: Array.isArray(this.formData.capabilities) ? this.formData.capabilities.join(',') : (this.formData.capabilities || ''),
      };
      
      if (typeof submitOverseasRegister !== 'function') {
        this.isSubmitting = false;
        Toast('提交接口未配置，请稍后重试');
        return;
      }
      submitOverseasRegister(submitData).then(res => {
        this.isSubmitting = false;
        Toast('提交成功，我们将尽快与您联系！');
        this.resetForm();
      }).catch(err => {
        this.isSubmitting = false;
        if (err && err.message) {
          Notify({ message: err.message, duration: 3000 });
        } else {
          Toast('提交失败，请稍后重试');
        }
      });
    },
    onFailed(errorInfo) {
      Toast('请完善必填信息');
    },
    resetForm() {
      this.formData = {
        companyName: '',
        contactName: '',
        position: '',
        phone: '',
        email: '',
        website: '',
        location: '',
        products: [],
        productOther: '',
        buildingDetail: '',
        materials: [],
        styles: [],
        businessStatus: '',
        currentMarkets: [],
        targetMarkets: [],
        partners: [],
        cooperation: [],
        capabilities: [],
      };
    }
  }
}
</script>

<style scoped lang="less">
// ==================== 颜色变量 ====================
@purplish-red: #E4007F;  // 主色调：品红色
@cyan: #00ABA5;         // 辅助色：青色（选中态）

// ==================== 移动端样式（≤1023px） ====================
@media screen and (max-width: 1023px) {

  // ---- 容器 ----
  .content-container {
    width: 100%;
    margin: 0 auto 20px;
    padding: 0;
  }

  // ---- 单选组容器（职位选择）----
  .radio-group-wrap {
    width: 100%;
    padding: 8px 0;
    .radio-item {
      margin: 0 10px 8px 0;
      padding: 4px 0;
      font-size: 14px;
    }
  }

  // ---- 头部横幅 ----
  .form-header {
    padding: 16px 14px;
    text-align: center;
    background: linear-gradient(135deg, rgb(110,69,135) 0%, #764ba2 100%);
    color: #fff;
    .page-title { font-size: 16px; margin: 0 0 6px; font-family: 'SourceHanSansCN-Bold'; }
    .page-subtitle { font-size: 14px; margin: 0 0 10px; font-family: 'SourceHanSansCN-Bold'; }
    .page-desc {
      font-size: 12px; line-height: 1.6; margin: 0 auto;
      color: rgba(255, 255, 255, 0.9);
      font-family: 'SourceHanSansCN-Light'; max-width: 300px;
    }
  }

  // ---- 表单主体 ----
  .form-container { width: 100%; background-color: #fff; padding: 0 14px; }
  .form-section { margin-bottom: 20px; }

  // ---- 分组标题（一、二、三...）----
  .section-title {
    display: flex; align-items: center;
    padding: 12px 0 10px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 10px;
    .title-num {
      display: inline-flex; align-items: center; justify-content: center;
      width: 20px; height: 20px;
      background: linear-gradient(135deg, rgb(110,69,135) 0%, #764ba2 100%);
      color: #fff;
      border-radius: 50%;
      font-size: 12px; font-family: 'SourceHanSansCN-Bold';
      margin-right: 6px;
      box-shadow: 0 2px 6px rgba(102, 126, 234, 0.4);
    }
    .title-text {
      font-size: 14px; font-family: 'SourceHanSansCN-Bold'; color: #060211;
    }
  }

  // ---- 问题区块 ----
  .question {
    margin-bottom: 24px;
    .question-title {
      font-size: 13px; color: #333;
      font-family: 'SourceHanSansCN-Medium'; margin-bottom: 10px;
      .hint { color: #999; font-size: 11px; font-weight: normal; font-family: 'SourceHanSansCN-Light'; }
    }
    .sub-field { margin-top: 8px; }
  }

  // ---- 提交说明提示框 ----
  .form-notice {
    background: linear-gradient(135deg, rgba(102,126,234,0.05) 0%, rgba(118,75,162,0.05) 100%);
    padding: 14px; border-radius: 6px; margin: 16px 0;
    border-left: 3px solid rgb(110,69,135);
    .notice-title { font-size: 13px; font-family: 'SourceHanSansCN-Bold'; color: #060211; margin-bottom: 6px; }
    p { font-size: 12px; line-height: 1.6; color: #666; margin: 0; }
  }

  // ---- 提交按钮 ----
  .submit-bar {
    padding: 16px 0 36px;
    display: flex; justify-content: center;
    .van-button--primary {
      background: linear-gradient(135deg, rgb(110,69,135) 0%, #764ba2 100%);
      border: none;
      border-radius: 4px !important;
      font-family: 'SourceHanSansCN-Medium'; font-size: 14px; text-align: center;
      white-space: nowrap;
      padding: 0 36px !important;
      height: 48px !important;
      line-height: 48px !important;
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }
  }

  // ---- Vant 组件深度覆盖 ----
  /deep/ .van-cell { font-size: 14px; padding: 14px 0; line-height: 1.5; margin-bottom: 8px; }

  // label 改为顶部单独一行显示
  /deep/ .van-field { display: block; padding: 0; }
  /deep/ .van-field__body { display: block; }
  /deep/ .van-cell__title {
    display: block; font-size: 14px; color: #333;
    font-family: 'SourceHanSansCN-Medium';
    padding: 0 !important; margin-right: 0; margin-bottom: 6px; width: 100%;
  }
  /deep/ .van-field__control { font-size: 14px; }
  /deep/ .van-field__control::placeholder { font-size: 13px; color: #bbb; }
  /deep/ .van-field__error-message { font-size: 12px; line-height: 1.5; }

  // 单选框（职位）
  /deep/ .van-radio__icon { font-size: 16px; }
  /deep/ .van-radio__label { font-size: 14px; }
  /deep/ .van-radio-group { display: flex; flex-wrap: wrap; width: 100%; }

  // ---- 职位单选组（span）----
  .position-group {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px 8px;
    width: 100%;
    padding: 8px 0;
  }
  .position-other-input {
    grid-column: 1 / -1;
    height: 36px; padding: 0 12px;
    border: 0px solid #e0e0e0;
    border-radius: 18px;
    font-size: 13px; outline: none;
    box-sizing: border-box;
    &:focus { border-color: @cyan; }
  }

  // ---- 自定义多选/选项（span）----
  .check-group {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px 8px;
    width: 100%;
  }
  .option-item {
    display: flex;
    align-items: center;
    line-height: 20px;
    gap: 10px;
  }
  .option-item label {
    font-size: 14px;
    cursor: pointer;
  }
  .check-item {
    display: inline-flex; align-items: center; justify-content: center;
    margin: 0 6px 8px 0; padding: 0 12px;
    height: 36px;
    border: 1px solid #e0e0e0; border-radius: 18px;
    font-size: 13px; color: #666;
    cursor: pointer; line-height: 1; box-sizing: border-box;
    transition: all 0.2s;
    &.active {
      background-color: #E6F5F4;
      border-color: @cyan;
      color: @cyan;
    }
  }

  // ---- 移动端地区选择（自定义，图标右对齐）----
  .mobile-location {
    padding: 12px 16px 4px;
    border-bottom: 0.3px solid #f0f0f0;
    margin-left: -12px;
    .mobile-location-label {
      font-size: 14px; color: #333;
      font-family: 'SourceHanSansCN-Medium';
      margin-bottom: 6px;
    }
    .mobile-location-input {
      display: flex; align-items: center;
      width: 100%;
      height: 20px;
      line-height: 20px;
      cursor: pointer;
    }
    .mobile-location-value {
      flex: 1; font-size: 14px; color: #333;
    }
    .mobile-location-placeholder {
      flex: 1; font-size: 14px; color: #bbb;
    }
    .mobile-location-arrow {
      font-size: 20px; color: #ccc; margin-left: auto;
      line-height: 1; transform: scaleX(0.7);
    }
  }
}

// ==================== PC端样式（≥1024px） ====================
@media screen and (min-width: 1024px) {

  // ---- 原生 checkbox/radio：去除浏览器默认绘制，统一用 CSS 画（尺寸转 rem，Ctrl+/- 不变）----
  input[type="checkbox"],
  input[type="radio"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 3px;           // 小写 px → 被 pxtorem 转 rem → Ctrl+/- 不随浏览器缩放变化
    height: 3px;
    min-width: 3px;
    min-height: 3px;
    border: 0.3px solid #c0c4cc;
    background-color: #fff;
    outline: none;
    cursor: pointer;
    vertical-align: middle;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    position: relative;
    flex-shrink: 0;
    transition: background-color 0.15s, border-color 0.15s;
  }
  input[type="radio"] {
    border-radius: 50%;
  }
  input[type="checkbox"] {
    border-radius: 0.4px;
  }
  input[type="checkbox"]:checked,
  input[type="radio"]:checked {
    border-color: #667eea;
    background-color: #667eea;
  }
  // 勾选标记用 ::before（独立元素，避免被浏览器最小像素限制截断）
  input[type="checkbox"]:checked::before {
    content: "";
    position: absolute;
    left: 0.8px;
    top: 0.15px;
    width: 0.9px;
    height: 1.8px;
    border: solid #fff;
    border-width: 0 0.25px 0.25px 0;
    transform: rotate(45deg);
    box-sizing: content-box;
  }
  input[type="radio"]:checked::before {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    width: 1.4px;
    height: 1.4px;
    background-color: #fff;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }
  .option-item {
    gap: 1.5px;         // 小写 px -> 转 rem，checkbox 与文字间距也随适配不随缩放变
  }
  .option-item label {
    margin-left: 0;
    line-height: 1;
    vertical-align: middle;
    cursor: pointer;
    font-size: 4px;            // 小写 px -> 转 rem -> Ctrl+/- 不随缩放变化
  }

  // ---- 容器 ----
  .content-container {
    width: 260px;
    margin: 4px auto 6px;
    padding: 0;
    box-sizing: border-box;
  }

  // ---- 单选组容器（职位选择）----
  .radio-group-wrap {
    width: 100%; padding: 4px 0;
    .radio-item { margin: 0 6px 3px 0; padding: 1px 0; font-size: 4px; }
  }
  /deep/ .van-radio-group { display: flex; flex-wrap: wrap; width: 100%; box-sizing: border-box; }
  /deep/ .van-radio { margin: 0 8px 4px 0; box-sizing: border-box; }
  /deep/ .van-radio__icon { font-size: 4px; }
  /deep/.van-field__control--custom { min-height: 0.1rem; }
  /deep/ .van-radio__label { font-size: 4px; color: inherit; margin-left: 1.5px; }

  // ---- 头部横幅 ----
  .form-header {
    padding: 6px 8px; text-align: center;
    background: linear-gradient(135deg, rgb(110,69,135) 0%, #764ba2 100%);
    color: #fff; border-radius: 1px 1px 0 0; box-sizing: border-box;
    .page-title { font-size: 7px; margin: 0 0 2px; font-family: 'SourceHanSansCN-Bold'; }
    .page-subtitle { font-size: 5px; margin: 0 0 3px; font-family: 'SourceHanSansCN-Bold'; }
    .page-desc {
      font-size: 4px; line-height: 1.5; margin: 0 auto;
      color: rgba(255, 255, 255, 0.9); font-family: 'SourceHanSansCN-Light';
    }
  }

  // ---- 表单主体 ----
  .form-container {
    width: 100%; background-color: #fff; padding: 4px 6px;
    box-shadow: 0 0.5px 2px rgba(0, 0, 0, 0.05);
    border-radius: 0 0 1px 1px; box-sizing: border-box;
  }
  .form-section { margin-bottom: 5px; padding-left: 12px; }

  // ---- 分组标题 ----
  .section-title {
    display: flex; align-items: center;
    padding: 4px 0 2px;
    border-bottom: 0.3px solid #f0f0f0;
    margin-bottom: 3px; margin-left: -12px; box-sizing: border-box;
    .title-num {
      display: inline-flex; align-items: center; justify-content: center;
      width: 8px; height: 8px;
      background: linear-gradient(135deg, rgb(110,69,135) 0%, #764ba2 100%);
      color: #fff;
      border-radius: 50%;
      font-size: 3.5px; font-family: 'SourceHanSansCN-Bold';
      margin-right: 2.5px; flex-shrink: 0;
      box-shadow: 0 0.5px 1.5px rgba(102, 126, 234, 0.4);
    }
    .title-text { font-size: 5px; font-family: 'SourceHanSansCN-Bold'; color: #060211; }
  }

  // ---- 问题区块 ----
  .question {
    margin-bottom: 4px; box-sizing: border-box;
    .question-title {
      font-size: 4.5px; color: #333;
      font-family: 'SourceHanSansCN-Medium'; margin-bottom: 2px;
      .hint { color: #999; font-size: 3.5px; font-weight: normal; font-family: 'SourceHanSansCN-Light'; }
    }
    .sub-field { margin-top: 2px; }
  }

  // ---- 提交说明提示框 ----
  .form-notice {
    background: linear-gradient(135deg, rgba(102,126,234,0.05) 0%, rgba(118,75,162,0.05) 100%);
    padding: 5px; border-radius: 1px; margin: 5px 0; box-sizing: border-box;
    border-left: 0.5px solid rgb(110,69,135);
    .notice-title { font-size: 4.5px; font-family: 'SourceHanSansCN-Bold'; color: #060211; margin-bottom: 2px; }
    p { font-size: 3.5px; line-height: 1.5; color: #666; margin: 0; }
  }

  // ---- 提交按钮 ----
  .submit-bar {
    padding: 5px 0 8px;
    display: flex; justify-content: center;
    .van-button--primary {
      background: linear-gradient(135deg, rgb(110,69,135) 0%, #764ba2 100%);
      border: none;
      border-radius: 2px !important;
      font-family: 'SourceHanSansCN-Medium'; font-size: 5px;
      text-align: center;
      white-space: nowrap;
      padding: 0 24px !important;
      height: 14px !important;
      line-height: 14px !important;
      box-shadow: 0 1px 3px rgba(102, 126, 234, 0.4);
    }
  }

  // ---- Vant 组件深度覆盖 ----
  /deep/ .van-form { width: 100%; box-sizing: border-box; }

  /deep/ .van-cell {
    font-size: 4.5px; width: 100%; box-sizing: border-box;
    padding: 4px 0 !important; line-height: 1.5; margin-bottom: 2px;
  }
  /deep/ .van-cell::after {
    left: 0 !important;
    right: 0 !important;
  }

  // label 改为顶部单独一行显示
  /deep/ .van-field { display: block; padding: 0; }
  /deep/ .van-field__body { display: block; }
  /deep/ .van-cell__title {
    display: block; font-size: 4.5px; color: #333;
    font-family: 'SourceHanSansCN-Medium';
    padding: 0 !important; margin-right: 0; margin-bottom: 3px; width: 100%;
  }
  /deep/ .van-cell__value { padding: 0 !important; }
  /deep/ .van-field__control {
    font-size: 3.5px; width: 100%; box-sizing: border-box;
    padding: 0.5px 0 !important; height: 7px; line-height: 7px; color: #333;
  }
  /deep/ .van-field__control::placeholder { font-size: 3.5px; color: #bbb; }
  /deep/ .van-field__left-icon { margin-right: 2px; }
  /deep/ .van-field__right-icon { margin-left: 2px; }
  /deep/ .van-field__error-message { font-size: 3.5px; line-height: 1.5; }

  // 按钮全局圆角和居中
  /deep/ .van-button {
    box-sizing: border-box; border-radius: 8px !important;
    text-align: center; justify-content: center;
    padding: 0 24px !important;
    height: 40px !important;
    line-height: 40px !important;
    white-space: nowrap;
  }

  // ---- PC端地区选择（3个el-select联动）----
  .pc-location-wrap {
    display: flex;
    flex-direction: column;
    margin-bottom: 4px;
    .pc-location-label {
      font-size: 4.5px;
      color: #333;
      font-family: 'SourceHanSansCN-Medium';
      margin-bottom: 2px;
    }
    .pc-location-selects {
      display: flex;
      gap: 2px;
      width: 100%;
    }
    .pc-location-select {
      flex: 1;
      min-width: 0;
      /deep/ .el-input {
        font-size: 0.1rem;
      }
      /deep/ .el-input__inner {
        height: 10px;
        line-height: 10px;
        font-size: 3.5px;
        border-radius: 1px;
        border: 0.3px solid #e0e0e0;
        &::placeholder { font-size: 3.5px; color: #bbb; }
      }
      /deep/ .el-input.is-focus .el-input__inner {
        border-color: #667eea;
      }
      /deep/ .el-input__icon {
        line-height: 10px;
        font-size: 4px;
        width: 8px;
        text-align: center;
      }
      /deep/ .el-input__suffix {
        line-height: 10px;
        right: 1px;
      }
    }
  }

  // ---- 职位单选组 / 多选组（grid 每行4个，选项对齐）----
  .position-group {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 3px 2px;
    width: 100%;
    padding: 4px 0;
    box-sizing: border-box;
  }
  .position-other-input {
    grid-column: 1 / -1;
    height: 7px;
    padding: 0.5px 5px;
    border: 0.3px solid #e0e0e0;
    border-radius: 1px;
    font-size: 3.5px;
    outline: none;
    box-sizing: border-box;
    margin-top: 2px;
    &:focus { border-color: #667eea; }
  }
  .check-group {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 3px 2px;
    width: 100%;
    box-sizing: border-box;
  }
  .option-item {
    display: flex;
    align-items: center;
    line-height: 10Px;
    white-space: nowrap;
  }

  // ---- 自定义多选（span胶囊）----
  .check-item {
    display: inline-flex; align-items: center; justify-content: center;
    margin: 0 2px 2px 0; padding: 0 5px;
    height: 12px;
    border: 0.3px solid #e0e0e0; border-radius: 6px;
    font-size: 3.5px; color: #666;
    cursor: pointer; line-height: 1; box-sizing: border-box;
    white-space: nowrap;
    transition: all 0.2s;
    &.active {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-color: transparent;
      color: #fff;
    }
  }
}
</style>

<!-- PC端下拉弹出面板样式（非scoped，因为弹出面板挂载到body上） -->
<style lang="less">
.pc-select-dropdown {
  .el-select-dropdown__wrap {
    max-height: 180Px;
    overflow-y: auto;
  }
  .el-select-dropdown__list {
    padding: 4Px 0;
  }
  .el-select-dropdown__item {
    font-size: 14Px;
    line-height: 22Px;
    height: 34Px;
    padding: 0 16Px;
    color: #606266;
    &.hover,
    &:hover {
      background-color: #f5f7fa;
    }
    &.selected {
      color: #667eea;
      font-weight: bold;
    }
  }
  .el-scrollbar__bar {
    right: 4Px;
    bottom: 4Px;
    width: 6Px;
    height: 6Px;
  }
  .el-scrollbar__thumb {
    background-color: #c0c4cc;
  }
}
</style>